import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../../config';

const EXPLORE_LINKS = [
  { name: 'The Assessment', href: '/assessment' },
  { name: 'What You Discover', href: '/what-you-discover' },
  { name: 'About', href: '/about' },
  { name: 'For Advisors', href: '/advisors' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-cream border-t border-secondary-200 mt-auto">
      {/* Quiet directory */}
      <div>
        <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 py-14">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            <div>
              <p className="font-serif text-lg text-secondary-900 mb-3">
                The Family Legacy Bridge
              </p>
              <p className="text-sm text-secondary-500 leading-relaxed max-w-xs">
                Helping families align on what their wealth is for — before it is
                tested.
              </p>
            </div>

            <div>
              <p className="text-[11px] font-semibold text-secondary-400 uppercase tracking-[0.18em] mb-4">
                Explore
              </p>
              <ul className="space-y-2.5">
                {EXPLORE_LINKS.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-600 hover:text-secondary-900 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="text-[11px] font-semibold text-secondary-400 uppercase tracking-[0.18em] mb-4">
                Contact
              </p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="text-sm text-secondary-600 hover:text-secondary-900 transition-colors"
              >
                {CONTACT_EMAIL}
              </a>
              <p className="text-xs text-secondary-400 mt-3">
                Confidential consultations by arrangement.
              </p>
              <Link
                to="/evaluation"
                className="inline-block mt-5 text-xs text-secondary-400 hover:text-secondary-700 underline underline-offset-4 transition-colors"
              >
                Family member with an access link
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Fine print */}
      <div className="border-t border-secondary-200">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 py-8">
          <p className="text-xs text-secondary-400 leading-relaxed max-w-3xl mb-6">
            The Family Legacy Bridge provides family wealth coaching and does not
            offer financial, investment, or tax advice. Amy Jaffe is not a
            registered Financial Services Provider under the FAIS Act. Please
            consult qualified professionals for financial decisions.
          </p>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <p className="text-xs text-secondary-400">
              © {currentYear} The Family Legacy Bridge
            </p>
            <div className="flex gap-8">
              <Link
                to="/privacy"
                className="text-xs text-secondary-400 hover:text-secondary-700 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-xs text-secondary-400 hover:text-secondary-700 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
